/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import Home from "@/view/home";
import About from "@/view/about";
import Product from "@/view/product";
import Contact from "@/view/contact";
import message from "@/view/message";
Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/about",
      name: "About",
      component: About,
    },
    {
      path: "/product",
      name: "Product",
      component: Product,
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
    },
    {
      path: "/message",
      name: "message",
      component: message,
    },
  ],
});

router.afterEach((to) => {
  // 设置 title
  window.scrollTo(0, 0);
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js